import copy from './copy'
import drag from './drag'
import resize from './resize'
import contextmenu from './contextmenu'
import resizable from './resizable'
import volcengine from './volcengine'
import cubeDrag from './cubeDrag'
import cubeResizer from './cubeResizer'
import tooltip from './tooltip'
export default {
  copy,
  drag,
  resize,
  contextmenu,
  resizable,
  volcengine,
  cubeDrag,
  cubeResizer,
  tooltip
}
